export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_BANKS: 'SET_BANKS',
    SET_SELECTED_BANK: 'SET_SELECTED_BANK',
    ADD_BANK: 'ADD_BANK',
    UPDATE_BANK: 'UPDATE_BANK',
    DELETE_BANK: 'DELETE_BANK',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    banks: [],
    selectedBank: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        status: null,
        type: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null
};

export const bankReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_BANKS:
            return {
                ...state,
                banks: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_BANK:
            return {
                ...state,
                selectedBank: action.payload,
                loading: false
            };

        case ACTIONS.ADD_BANK:
            return {
                ...state,
                banks: [action.payload, ...state.banks],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_BANK:
            return {
                ...state,
                banks: state.banks.map((bank) => (bank.id === action.payload.id ? action.payload.data : bank)),
                selectedBank: state.selectedBank?.id === action.payload.id ? action.payload.data : state.selectedBank,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_BANK:
            return {
                ...state,
                banks: state.banks.filter((bank) => bank.id !== action.payload),
                selectedBank: state.selectedBank?.id === action.payload ? null : state.selectedBank,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
